import Finger, { Status } from '../../../../atoms/finger';
import ChecklistSection from '../../../../atoms/checklist-section';
import { getVisible } from '../../../../../utilities/documents';
import { ImmigrationStatusPdfCopyDocMap, ImmigrationStatusShareCodeDocMap } from 'types';

interface IProps {
  shareCodeDocuments: ImmigrationStatusShareCodeDocMap;
  pdfCopyDocuments: ImmigrationStatusPdfCopyDocMap;
  openDocumentModal: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string,
    docKey: string,
    modalTitle: string,
    fileNames: string[],
    isComplete: boolean,
    biometricResidencePermit?: any
  ) => void;
}

export const ImmigrationStatusShareCodeDocs = (props: IProps) => {
  const { shareCodeDocuments: shareCodeDocs, pdfCopyDocuments: pdfCopyDocs, openDocumentModal } = props;

  if (Object.keys(shareCodeDocs ?? {}).length === 0 || Object.keys(pdfCopyDocs ?? {}).length === 0) {
    return null;
  }
  const visibleShareCodeDocs = getVisible(shareCodeDocs, false);
  const visiblePdfCopyDocs = getVisible(pdfCopyDocs, false);

  if (visibleShareCodeDocs.length + visiblePdfCopyDocs.length === 0) {
    return null;
  }

  const openShareCodeModal = (data: { title: string; docKey: string; fileNames: string[]; isComplete: boolean }) => {
    openDocumentModal(
      'beforeTravel',
      null,
      'immigrationStatusShareCode',
      data.docKey,
      data.title,
      data.fileNames,
      data.isComplete
    );
  };
  const openPdfCopyModal = (data: { title: string; docKey: string; fileNames: string[]; isComplete: boolean }) => {
    openDocumentModal(
      'beforeTravel',
      null,
      'immigrationStatusPdfCopy',
      data.docKey,
      data.title,
      data.fileNames,
      data.isComplete
    );
  };

  const renderedShareCodeDocs = visibleShareCodeDocs.map(({ item, key: travelTicketKey }, index) => {
    const label = `Immigration Status: Share Code ${index > 0 ? index + 1 : ''}`;
    switch (item.status) {
      case 'REJECTED': {
        return (
          <Finger
            key={travelTicketKey}
            id={travelTicketKey}
            hideButton={true}
            status={Status.Rejected}
            reason={item.reason}
            label={label}
          />
        );
      }
      case 'APPROVED':
      case 'UPLOADED_OK':
      case 'REPLACED': {
        return (
          <Finger
            key={travelTicketKey}
            id={travelTicketKey}
            status={Status.Complete}
            completeLabel={'Done'}
            label={label}
            onClick={() =>
              openShareCodeModal({
                isComplete: true,
                fileNames: item.fileNames,
                docKey: travelTicketKey,
                title: label
              })
            }
          />
        );
      }
      default: {
        return (
          <Finger
            key={travelTicketKey}
            id={travelTicketKey}
            status={Status.InProgress}
            completeLabel={'Done'}
            label={label}
            onClick={() =>
              openShareCodeModal({
                isComplete: false,
                fileNames: item.fileNames,
                docKey: travelTicketKey,
                title: label
              })
            }
          />
        );
      }
    }
  });

  const renderedPdfCopyDocs = visiblePdfCopyDocs.map(({ item, key: travelTicketKey }, index) => {
    const label = `Immigration Status: PDF ${index > 0 ? index + 1 : ''}`;
    switch (item.status) {
      case 'REJECTED': {
        return (
          <Finger
            key={`immigration-status-share-code-${travelTicketKey}`}
            id={`immigration-status-share-code-${travelTicketKey}`}
            hideButton={true}
            status={Status.Rejected}
            reason={item.reason}
            label={label}
          />
        );
      }
      case 'APPROVED':
      case 'UPLOADED_OK':
      case 'REPLACED': {
        return (
          <Finger
            key={`immigration-status-share-code-${travelTicketKey}`}
            id={`immigration-status-share-code-${travelTicketKey}`}
            status={Status.Complete}
            completeLabel={'Done'}
            label={label}
            onClick={() =>
              openPdfCopyModal({
                isComplete: true,
                fileNames: item.fileNames,
                docKey: travelTicketKey,
                title: label
              })
            }
          />
        );
      }
      default: {
        return (
          <Finger
            key={`immigration-status-share-code-${travelTicketKey}`}
            id={`immigration-status-share-code-${travelTicketKey}`}
            status={Status.InProgress}
            completeLabel={'Done'}
            label={label}
            onClick={() =>
              openPdfCopyModal({
                isComplete: false,
                fileNames: item.fileNames,
                docKey: travelTicketKey,
                title: label
              })
            }
          />
        );
      }
    }
  });

  return (
    <>
      <ChecklistSection label={`Digital Immigration Status`}>
        {renderedShareCodeDocs}
        {renderedPdfCopyDocs}
      </ChecklistSection>
    </>
  );
};
